import { Component} from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-vendor-login',
  templateUrl: './vendor-login.component.html',
  styleUrls: ['./vendor-login.component.scss'],
})
export class VendorLoginComponent {

  loader:boolean=false;
  check: boolean = false;
  Cid;mob;
  VendoruserId;
  numCd = '+91';
  numb;
  hide;
  pass;

  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { 
        document.addEventListener('keydown', function (e:any) {
          if (e.keyCode == 13) {
            sessionStorage.setItem('login','true')
          }
        });
      }

   
  login() {
    this.loader = true;
    let post = {
      "password": btoa(this.pass),
      "appId": "14"
    } 
    sessionStorage.removeItem("login");
    Object.assign(post,{"emailId":this.numCd+this.numb})
    this.auth.login(post).subscribe((res: any) => {
      if(res.accountEnabledInd){  
        this.handler.loginVendorRes(res);            
        window['mock'] = res;   
        this.handler.res('Welcome back user');
       this.auth.getUser();
        this.getCapability(res.userId); 
        // this.auth.getConfig();
      }else{
        this.handler.res("Pending Approval");
        this.loader = false; 
      }
    },
      err => {
        this.handler.err(err)
        this.loader = false;
      })
  }

  getCapability(id) {
      this.service.getCapability(id).subscribe((res: any) => {    
          let capabilities = res.capabilities.map(({ code }) => code);
          localStorage.setItem('capability', JSON.stringify(capabilities));
          localStorage.setItem('capabilityOrg', JSON.stringify(res.orgs)); 
          if(localStorage.getItem('capabilityOrg')) {
             this.loader = false;
             this.route();
             this.auth.getOrg();
          }    
          },
        err => {
          this.handler.err(err);
          this.loader = false;
        })
  
  }

  forgot(){
    this.router.navigate(['/vendorValidate']);
  }

  ionViewWillLeave(){
    this.numb = undefined;
    this.pass = undefined;
  }

  route(){
    if(this.auth.checkCapability('SP')){
      this.router.navigate(['/vendor-request']);
      }else if (this.auth.checkCapability('SC')){
       this.router.navigate(['/requests']);
      }else if (this.auth.checkCapability('CUST')){
        this.router.navigate(['/bookservice1']);
       }  
  }

  
  ngDoCheck(){
    if(sessionStorage.getItem('login')=='true'){
      this.login()
    }
  }


}
